import React from "react";
import Lottie from "lottie-react";
import LevelAdvanceNotice from "./common/LevelAdvanceNotice";

/**
 * GameOverScreen — the shared celebratory "game over" sheet of paper.
 *
 * Extracted from the identical markup that Time Match (×2) and Find the Middle
 * each carried inline, so every game's end screen reads the same. All styling
 * lives in theme.css (.game-over-screen / .game-over-stats / .game-over-button).
 *
 * @param {string}   [heading]            Big line on the card (default "The game is over!").
 * @param {string[]} [stats]              Lines shown in the stats panel; omit/empty to hide it.
 * @param {Function} [onRestart]          Restart handler; omit to hide the button (terminal screen).
 * @param {string}   [restartLabel]       Restart button text.
 * @param {boolean}  [showFireworks]      Whether to play the fireworks burst.
 * @param {object}   [fireworksAnimation] Lottie animation data (each game passes its own asset).
 */
export default function GameOverScreen({
  heading = "The game is over!",
  stats = [],
  onRestart,
  restartLabel = "Start a new game",
  showFireworks = false,
  fireworksAnimation,
}) {
  return (
    <div className="game-over-screen">
      {showFireworks && fireworksAnimation && (
        <div className="fireworks-container">
          <Lottie animationData={fireworksAnimation} loop={true} autoplay={true} />
        </div>
      )}
      <h2>{heading}</h2>
      {stats.length > 0 && (
        <div className="game-over-stats">
          {stats.map((line, i) => (
            <p key={i}>{line}</p>
          ))}
        </div>
      )}
      {onRestart && (
        <button
          type="button"
          onClick={onRestart}
          className="btn btn-primary game-over-button"
        >
          {restartLabel}
        </button>
      )}
      <LevelAdvanceNotice />
    </div>
  );
}
